<template>
    <div class="workExperiences">
        <div class="workExperiences_title">
            <div class="workExperiences_title_left">
                <span style="font-size: 14px;padding-left: 10px;margin-bottom: 10px;border-left: 3px solid var(--subjectColor);">过往学习/工作经历</span>
            </div>
            <div class="workExperiences_title_right">
                <el-button v-if="canEdit" size="mini" @click="addworkExperiences">添加</el-button>
            </div>
        </div>
        <el-table :data="vo.passenger.workExperiences" border="1px" style="width: 100%" class="workExperiencesList">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="certificatesName" label="开始时间" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="startDate"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'date', emptyMessage: '请选择开始时间', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '开始时间', propName: 'startDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月', valueMaxLength: null, valueMinLength: null, model: 'scope.row.startDate', option: [], weekday: 0 }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesSn" label="结束时间" align="center" width="180px">
                <template slot-scope="scope">
                    <form-item
                        ref="endDate"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'date', emptyMessage: '请选择结束时间', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '结束时间', propName: 'endDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月', valueMaxLength: null, valueMinLength: null, model: 'scope.row.endDate', option: [], weekday: 0 }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="certificatesDate" label="工作（学习）名称" align="center">
                <template slot-scope="scope">
                    <form-item
                        ref="jobContet"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: 70, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入工作内容', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '工作（学习）名称', propName: 'jobContet', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.jobContet', option: [], autosize: false }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column v-if="canEdit" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link type="primary" @click="delClick(scope.row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'WorkExperiences',
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        isMypersonalRecords: { type: Boolean, default: false },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        return {
            feeTypeRules
        }
    },
    data() {
        return {
            // 通用变量
            loginUser: this.$store.getters.loginUser,
            uploadRow: {},
            uploadAttachList: [] // 当前待上传附件列表
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {},
    updated() {},
    methods: {
        addworkExperiences() {
            this.$http({
                method: 'POST',
                url: '/rsgl/workExperience/addNew'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    this.vo.passenger.workExperiences.push(res.body.vo)
                }
            })
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            this.vo.passenger.workExperiences = this.vo.passenger.workExperiences.filter((item) => item.id !== row.id)
        }
    }
}
</script>

<style scoped lang="scss">
.workExperiences_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: #f2f5fb;
    // border: 1px solid #e3e8ee;
    // padding: 4px 6px !important;
    padding: 4px 6px 4px 0 !important;
    font-size: 14px;
    color: #333;
}
</style>
